import { createAction } from 'redux-act'

export const submitConfig = createAction()
export const submitLogin = createAction()
export const submitLoginAgency = createAction()

export const receiveAuthData = createAction()
export const unauthorizeUser = createAction()
export const changeBackAddress = createAction()